import { atom } from 'jotai';

export const durationStartTimeAtom = atom(undefined);
export const durationEndTimeAtom = atom(undefined);
export const formPageTypeAtom = atom('YieldPage');
export const dynamicLimitBpsFormatAtom = atom(false);
